import { useEffect, useState } from "react";

/**
 * Tracks the browser's connectivity state so components can adapt to being
 * offline (hide voice-only features, show a friendly banner, etc.).
 *
 * We treat `navigator.onLine === false` as authoritative and additionally
 * listen to a lightweight `online`/`offline` event pair. Some browsers lie
 * about `navigator.onLine`, so consumers should also handle fetch errors
 * gracefully — this hook is best-effort UX, not a network guarantee.
 */
export default function useOnlineStatus() {
  const [online, setOnline] = useState(
    typeof navigator === "undefined" ? true : navigator.onLine,
  );

  useEffect(() => {
    if (typeof window === "undefined") return;
    const on  = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);

  return online;
}
